import StoreStateInterface from './store-state-interface';
import CcCustomer from '@/main/webapp/resources/src/vue/domain/user/cc-customer';
import CcWishlistTempParams from "@/main/webapp/resources/src/vue/domain/user/cc-wishlist-temp-params";

const storeState: StoreStateInterface = {
	appKey: 1,
	readyToStart: false,
	categories: [],
	products: [],
	productStocks: [],
	pageData: {
		number: 0,
		size: 0,
		totalPages: 0,
		totalElements: 0
	},
	user: null,
	order: null,
	orderNotes: '',
	orders: [],
	ordersPageData: {
		number: 0,
		size: 0,
		totalPages: 0,
		totalElements: 0
	},
	stores: [],
	searchParams: {
		categoryPaths: '',
		descriptionLike: '',
		attribute: [],
		brands: [],
		customSort: null,
		timestamp: 0,
		productTags: [],
		onSale: false
	},
	categoryPathsForCategoryPanel: [],
	bannerAreaHome: null,
	bannerAreaHomePrivate: null,
	bannerAreaProducts: null,
	bannerAreaRegistration: null,
	bannerAreaShoppingCart: null,
	searchAids: [],
	provinces: [],
	brands: [],
	lines: [],
	features: [],
	isStoreOptionsShowed: false,
	urlPreLogin: '',
	disabledDates: [],
	customerShippingForm: {
		errors: [],
		shippingData: {}
	},
	secondaryCustomers: [],
	secondaryCustomersPageData: {
		number: 0,
		size: 0,
		totalPages: 0,
		totalElements: 0
	},
	productTags: [],
	productTagsInitialized: false,
	collectTimeOptions: [],
	wishlists: [],
	wishlistsTempParams: new CcWishlistTempParams(),
	wishlistsInitialized: false,
};
export default storeState;
